import { render } from "./ProjectActionNotificator.vue?vue&type=template&id=4609dd06"
import script from "./ProjectActionNotificator.vue?vue&type=script&lang=js"
export * from "./ProjectActionNotificator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__